/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';

function FormQuantity({ parent, edit }) {
  const [attr, setAttr] = useState(parent);
  const [focus, setFocus] = useState(false);
  const [quantityChange, setQuantityChange] = useState(parent.quantity);

  const send = () => {
    if (attr.quantity !== quantityChange) {
      setQuantityChange(attr.quantity);
      edit({ id: attr.id, quantity: attr.quantity }, 'QUANTITY');
    }
  };

  return (
    <MDBox
      noValidate
      component='form'
      role='form'
      onSubmit={(e) => {
        e.preventDefault();

        send();
      }}
    >
      <MDInput
        value={attr.quantity}
        type='number'
        onChange={(e) => setAttr({ ...attr, quantity: e.target.value })}
        onFocus={(e) => {
          setFocus(true);
          e.target.select();
        }}
        onBlur={() => {
          if (focus) {
            setFocus(false);

            send();
          }
        }}
        variant='standard'
        fullWidth
        inputProps={{
          maxLength: 20,
          autoComplete: 'off',
          className: 'text-right',
          sx: { minWidth: 80 },
        }}
      />
    </MDBox>
  );
}

FormQuantity.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    quantity: PropTypes.string.isRequired,
  }).isRequired,
  edit: PropTypes.func.isRequired,
};

export default FormQuantity;
